import {
    FETCH_AI_CHATBOT_THREADS,
    CLEAN_AI_CHATBOT_THREADS,
    DELETE_AI_CHATBOT_THREAD,
    DELETE_AI_CHATBOT_THREADS,
    CHANGE_AI_CHATBOT_THREAD_COMMENT,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_CHATBOT_THREADS_DEFAULT_STATE = {};

const AiChatbotThreadsReducer = (state = AI_CHATBOT_THREADS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_CHATBOT_THREADS:
            return payload;

        case CHANGE_AI_CHATBOT_THREAD_COMMENT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, comment: payload.comment };
                }

                return item;
            }) };

        case CLEAN_AI_CHATBOT_THREADS:
        case DELETE_AI_CHATBOT_THREAD:
        case DELETE_AI_CHATBOT_THREADS:
            return AI_CHATBOT_THREADS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiChatbotThreadsReducer;
